export default __webpack_public_path__ + "static/media/globeVector.3fe287be.svg";